'use client'

import dynamic from 'next/dynamic'

const DistinctiveFactorsChartRadar = dynamic(() => import('./DistinctiveFactorsChartRadar'), { ssr: false })

export default DistinctiveFactorsChartRadar
